import React from 'react';
import logo from './prenetics-logo.png';
import styled from 'styled-components';

type Props = {
  monochrome?: boolean;
  className?: string;
};

const MonochromeLogo = styled.img`
  filter: grayscale(5) brightness(100);
`;

export class PreneticsLogo extends React.PureComponent<Props> {
  render() {
    const className = `PreneticsLogo ${this.props.className}`;
    return this.props.monochrome
      ? <MonochromeLogo className={className} src={logo} />
      : <img alt="" className={className} src={logo} />;
  }
}
